//accordion start
const accordion = document.querySelectorAll(".faq__content-item-title");

accordion.forEach((accordionElem) => {
    accordionElem.onclick = function () {
    this.classList.toggle("is-open");

    let content = this.nextElementSibling;
    //console.log(content);

    if (content.style.maxHeight) {
      //this is if the accordion is open
      content.style.maxHeight = null;
    } else {
      //if the accordion is currently closed
      content.style.maxHeight = content.scrollHeight + "px";
      //console.log(content.style.maxHeight);
    }
  };
});
//accordion end

//faq buttons start
const faqBtnS = document.querySelectorAll(".faq__nav-item");
const faqContentItemS = document.querySelectorAll(".faq__content-item");
const faqTitleD = document.getElementById("faq__content-top-title-d");
const faqTitleM = document.getElementById("faq__content-top-title-m");
const faqTitleMShow = document.getElementById("faq__content-top-title");
const faqContList = document.getElementById("faq__content-list");

faqBtnS.forEach((faqBtn) => {
  faqBtn.onclick = function (e) {
    e.preventDefault();

    faqBtnS.forEach((faqBtn) => {
      faqBtn.classList.remove("active");
    });

    this.classList.add("active");

    let url = this.getAttribute("href");
    faqContentItemS.forEach((faqContentItem) => {
      faqContentItem.style.display = "none";
      if(hasClass(faqContentItem, url)) {
        faqContentItem.style.display = "block";
      }
    });

    faqContList.style.padding = "0 0 29px";
    faqTitleMShow.style.display = "block";
    let faqNavGetTxtCont = this.textContent;
    faqTitleD.textContent = faqNavGetTxtCont;
    faqTitleM.textContent = ' / '+faqNavGetTxtCont;
  };  
});
//faq buttons end

//faq search start
var faqSearchF = document.getElementById("faq__content-top-search");
faqSearchF.addEventListener("submit", (event) => { 
  faqSearch();
  event.preventDefault();
});

var faqSearchInput = document.getElementById("faq__content-top-search-input");
faqSearchInput.addEventListener('input', function () {
  faqSearch();
});

function faqSearch() {
  const faqBtnS2 = document.querySelectorAll(".faq__nav-item");
  const faqContentItemS2 = document.querySelectorAll(".faq__content-item");
  const faqTitleD2 = document.getElementById("faq__content-top-title-d");
  const faqTitleM2 = document.getElementById("faq__content-top-title-m");
  const faqTitleMShow2 = document.getElementById("faq__content-top-title");
  const faqContList2 = document.getElementById("faq__content-list");
  var faqSearchInputV = document.getElementById("faq__content-top-search-input").value;
  var faqSearchInputLC = faqSearchInputV.toLowerCase();

  faqContentItemS2.forEach((faqContentItem2) => {
    let child1 = faqContentItem2.querySelector('.faq__content-item-title span:first-child').textContent.toLowerCase();
    //let child2 = faqContentItem.querySelector('.faq__content-item-text-in').textContent.toLowerCase();
    faqContentItem2.style.display = "none";
    let srest1 = child1.includes(faqSearchInputLC);
    //let temp2 = child2.contains(faqSearchInputLC);
    if(srest1) {
      faqContentItem2.style.display = "block";
    }   
  });

  faqBtnS2.forEach((faqBtn2) => {
    faqBtn2.classList.remove("active");
  });
  faqContList2.style.padding = "0 0 29px";
  faqTitleMShow2.style.display = "block";
  faqTitleD2.textContent = faqSearchInputV;
  faqTitleM2.textContent = ' / '+faqSearchInputV; 
}

//faq search end